<template>
 <div>
  <GridIndex></GridIndex>
 </div>
</template>

<script lang = "ts" >
import GridIndex from "./components/GridIndex.vue";
import {defineComponent} from "vue";
export default defineComponent({
 name: "PatBem",
 components: { GridIndex },
});
</script>
